module.exports = __webpack_public_path__ + "img/1920x1080.a3d16b3c.png";